/** Construtores de blocos com padrões sensatos, para deixar o construtor legível. */
export function texto(conteudo, opcoes = {}) {
    return {
        tipo: 'TEXTO',
        texto: conteudo,
        tamanho: opcoes.tamanho ?? 'MD',
        peso: opcoes.peso ?? 'NORMAL',
        cor: opcoes.cor ?? 'TEXTO',
        alinhamento: opcoes.alinhamento ?? 'ESQ',
        italico: opcoes.italico,
        maiusculas: opcoes.maiusculas,
        tracking: opcoes.tracking,
        espacoAcimaMm: opcoes.espacoAcimaMm ?? 0,
        espacoAbaixoMm: opcoes.espacoAbaixoMm ?? 0,
        entrelinha: opcoes.entrelinha,
    };
}
export function linhas(opcoes = {}) {
    return {
        tipo: 'LINHAS',
        estilo: (opcoes.estilo ?? 'LINHA'),
        alturaLinhaMm: opcoes.alturaLinhaMm ?? 7,
        espacamentoMm: opcoes.espacamentoMm ?? 0,
        rotulo: opcoes.rotulo,
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
        flexivel: opcoes.flexivel ?? true,
        alturaMm: opcoes.alturaMm,
        linhas: opcoes.linhas,
        colunas: opcoes.colunas ?? 1,
        comData: opcoes.comData ?? false,
        traco: opcoes.traco,
        motivo: opcoes.motivo,
        motivoModo: opcoes.motivoModo,
        motivoACadaNLinhas: opcoes.motivoACadaNLinhas,
        motivoEspacamentoMm: opcoes.motivoEspacamentoMm,
        motivoTamanhoMm: opcoes.motivoTamanhoMm,
        motivoLado: opcoes.motivoLado,
        corMotivo: opcoes.corMotivo,
    };
}
/**
 * Grade de horários: uma linha por hora, com o rótulo ao lado.
 *
 * A lista de horas vem pronta do motor (`horasDaGrade`): o desenho não decide
 * quantas linhas existem, só divide a altura que recebeu entre elas.
 */
export function horarios(itens, opcoes = {}) {
    return {
        tipo: 'HORARIOS',
        itens,
        alturaLinhaMm: opcoes.alturaLinhaMm ?? 6,
        corLinha: opcoes.corLinha ?? 'LINHA',
        corRotulo: opcoes.corRotulo ?? 'TEXTO_SUAVE',
        rotulo: opcoes.rotulo,
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
    };
}
export function checklist(itens, opcoes = {}) {
    return {
        tipo: 'CHECKLIST',
        itens,
        marcador: opcoes.marcador ?? 'QUADRADO',
        cor: opcoes.cor ?? 'TEXTO',
        alturaLinhaMm: opcoes.alturaLinhaMm ?? 7,
        rotulo: opcoes.rotulo,
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
    };
}
export function grade(opcoes = {}) {
    return {
        tipo: 'GRADE',
        estilo: opcoes.estilo ?? 'PONTO',
        tamanhoMalhaMm: opcoes.tamanhoMalhaMm ?? 5,
        rotulo: opcoes.rotulo,
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
        flexivel: opcoes.flexivel ?? true,
        alturaMm: opcoes.alturaMm,
    };
}
export function caixa(opcoes = {}) {
    return {
        tipo: 'CAIXA',
        titulo: opcoes.titulo,
        descricao: opcoes.descricao,
        conteudo: opcoes.conteudo,
        fundo: opcoes.fundo ?? 'SUAVE',
        borda: opcoes.borda ?? 'NENHUMA',
        raioMm: opcoes.raioMm ?? 2,
        preenchimentoMm: opcoes.preenchimentoMm ?? 3,
        corTitulo: opcoes.corTitulo ?? 'DESTAQUE_TEXTO',
        tamanhoTitulo: opcoes.tamanhoTitulo ?? 'XS',
        alinhamento: opcoes.alinhamento,
        flexivel: opcoes.flexivel ?? false,
        alturaMm: opcoes.alturaMm,
    };
}
export function separador(opcoes = {}) {
    return {
        tipo: 'SEPARADOR',
        estilo: opcoes.estilo ?? 'LINHA',
        cor: opcoes.cor ?? 'LINHA',
        espessuraMm: opcoes.espessuraMm ?? 0.25,
        espacoMm: opcoes.espacoMm ?? 2,
        motivo: opcoes.motivo,
        motivoTamanhoMm: opcoes.motivoTamanhoMm,
        corMotivo: opcoes.corMotivo,
    };
}
export function espaco(alturaMm, flexivel = false) {
    return { tipo: 'ESPACO', alturaMm, flexivel };
}
export function tabela(colunas, opcoes = {}) {
    return {
        tipo: 'TABELA',
        colunas,
        larguras: opcoes.larguras ?? colunas.map(() => 1 / colunas.length),
        linhas: opcoes.linhas ?? 20,
        celulas: opcoes.celulas,
        alturaLinhaMm: opcoes.alturaLinhaMm ?? 7,
        fundo: opcoes.fundo ?? 'NENHUM',
        borda: opcoes.borda ?? 'SUAVE',
        rotulo: opcoes.rotulo,
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
        flexivel: opcoes.flexivel ?? true,
        alturaMm: opcoes.alturaMm,
    };
}
export function miniCalendario(ano, mes, opcoes = {}) {
    return {
        tipo: 'MINI_CALENDARIO',
        ano,
        mes,
        destacar: opcoes.destacar,
        mostrarNumeroSemana: opcoes.mostrarNumeroSemana ?? false,
        rotulo: opcoes.rotulo,
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
        semDatas: opcoes.semDatas ?? false,
        preenchimentoMm: opcoes.preenchimentoMm ?? 0,
        feriados: opcoes.feriados,
        mostrarNomesFeriados: opcoes.mostrarNomesFeriados ?? false,
    };
}
export function campos(itens, opcoes = {}) {
    return {
        tipo: 'CAMPOS',
        itens,
        alturaLinhaMm: opcoes.alturaLinhaMm ?? 7,
        cor: opcoes.cor ?? 'TEXTO',
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
        rotuloAbaixo: opcoes.rotuloAbaixo ?? false,
        mascaraCor: opcoes.mascaraCor ?? 'TEXTO_SUAVE',
    };
}
export function grupo(blocos, opcoes = {}) {
    return {
        tipo: 'GRUPO',
        colunas: opcoes.colunas ?? 3,
        blocos,
        gapMm: opcoes.gapMm ?? 3,
        celulasVisiveis: opcoes.celulasVisiveis ?? false,
        preenchimentoCelulaMm: opcoes.preenchimentoCelulaMm ?? 2,
        centralizarCelulas: opcoes.centralizarCelulas ?? false,
        flexivel: opcoes.flexivel ?? true,
        alturaMm: opcoes.alturaMm,
        rotulo: opcoes.rotulo,
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
    };
}
export function coluna(fracao, blocos) {
    return { fracao, blocos };
}
/** Bloco de imagem isolado (usado no caderno de desenho). */
export function imagem(url, opcoes = {}) {
    return {
        tipo: 'IMAGEM',
        url,
        proporcao: opcoes.proporcao ?? null,
        ajuste: opcoes.ajuste ?? 'CONTER',
        legenda: opcoes.legenda,
        moldura: opcoes.moldura ?? true,
        preenchimentoMm: opcoes.preenchimentoMm ?? 0,
        corLegenda: opcoes.corLegenda ?? 'TEXTO_SUAVE',
        flexivel: opcoes.flexivel ?? true,
        alturaMm: opcoes.alturaMm,
    };
}
/** Folha de caligrafia com guias de traçado. */
export function caligrafia(opcoes = {}) {
    return {
        tipo: 'CALIGRAFIA',
        linhas: opcoes.linhas ?? 12,
        alturaLinhaMm: opcoes.alturaLinhaMm ?? 16,
        estilo: opcoes.estilo ?? 'CURSIVA',
        cor: opcoes.cor ?? 'TEXTO',
        corGuia: opcoes.corGuia ?? 'LINHA',
        rotulo: opcoes.rotulo,
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
    };
}
/** Pentagramas para o caderno de partitura. */
export function partitura(opcoes = {}) {
    return {
        tipo: 'PARTITURA',
        sistemas: opcoes.sistemas ?? 10,
        espacamentoLinhaMm: opcoes.espacamentoLinhaMm ?? 2,
        espacoEntreSistemasMm: opcoes.espacoEntreSistemasMm ?? 6,
        cor: opcoes.cor ?? 'TEXTO',
        barraFinal: opcoes.barraFinal ?? true,
        rotulo: opcoes.rotulo,
        rotuloCor: opcoes.rotuloCor ?? 'TEXTO_SUAVE',
    };
}
/** Bloco de campos com rótulo e linha, para fichas. */
export function ficha(titulo, itens, opcoes = {}) {
    return caixa({
        titulo,
        conteudo: [campos(itens, { alturaLinhaMm: opcoes.alturaLinhaMm ?? 7 })],
        fundo: opcoes.fundo ?? 'SUAVE',
        borda: opcoes.borda ?? 'NENHUMA',
        raioMm: 3,
        preenchimentoMm: 4,
        flexivel: opcoes.flexivel ?? false,
        alturaMm: opcoes.alturaMm,
    });
}
export function secao(id, blocos, opcoes = {}) {
    const base = {
        id,
        alturaMm: opcoes.alturaMm ?? null,
        peso: opcoes.peso ?? 1,
        preenchimentoMm: opcoes.preenchimentoMm ?? 0,
        fundo: (opcoes.fundo ?? 'NENHUM'),
        borda: (opcoes.borda ?? 'NENHUMA'),
        raioMm: opcoes.raioMm ?? 2,
        gapMm: opcoes.gapMm ?? 3,
        alinhamentoVertical: opcoes.alinhamentoVertical ?? 'TOPO',
    };
    if (opcoes.colunas)
        return { ...base, colunas: opcoes.colunas };
    return { ...base, blocos };
}
/** Açúcar sintático para textos de título de seção (versalete com tracking). */
export function rotulo(conteudo, cor = 'DESTAQUE_TEXTO', tamanho = 'XS') {
    return texto(conteudo, {
        tamanho,
        cor,
        maiusculas: true,
        tracking: 0.14,
        peso: 'FORTE',
        espacoAbaixoMm: 1.5,
    });
}
//# sourceMappingURL=blocos.js.map